import React, { Component } from "react";

import Footer from "./Footer";

const styles = {
  footerContainer: {
    position: "fixed",
    bottom: 0,
    left: 0,
    width: "100%",
    alignItems: "center",
    justifyContent: "center"
  }
};

export default class FixedFooter extends Component {
  render() {
    return (
      <div style={styles.footerContainer}>
        <Footer />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/FixedFooter.js